import lottie from 'lottie-web/build/player/lottie_light';

export const masthead = () => {
  const advanceArrow = document.querySelector('.masthead--advance-arrow');
  if (advanceArrow) {
    advanceArrow.addEventListener('click', function (e) {
      e.preventDefault();
      const masthead = this.closest('.masthead');
      const nextGroup = masthead.nextElementSibling;
      if (nextGroup && nextGroup.classList.contains('wp-block-group')) {
        const elOffsetTop = nextGroup.offsetTop;
        window.scrollTo({
          top: elOffsetTop,
          behavior: 'smooth'
        });
      }
    });
  }

  // const splashAdvance = document.querySelector('#splash--advance');

  // if (splashAdvance) {
  //   splashAdvance.addEventListener('click', () => {
  //     document.body.classList.add('exit-lottie');
  //     splashBtn.classList.add('faded'); // Hide the arrow
  //   });
  // }
  // const dotLottie = new DotLottie({
  //     autoplay: true,
  //     loop: true,
  //     canvas: document.querySelector('#dotlottie-canvas'),
  //     src: "<https://lottie.host/47017153-a043-4acc-b04b-0d6d3969e8ba/UQPMe3TmGx.lottie>", // replace with your .lottie or .json file URL
  // });

}
